var map = {
	"./其他.png": 1776,
	"./其它平台.jpg": 66810,
	"./冷链.png": 34824,
	"./冷链运输平台.jpg": 88512,
	"./制造与商贸企业平台.jpg": 17480,
	"./协会.png": 9796,
	"./危化.png": 25598,
	"./危化运输平台.jpg": 26947,
	"./商砼.png": 40267,
	"./商砼运输平台.jpg": 90310,
	"./商贸.png": 33891,
	"./家具.png": 47954,
	"./家具配送平台.png": 73105,
	"./普货运输.png": 33790,
	"./物流.png": 9764,
	"./物流承运商平台.jpg": 23642,
	"./行业协会平台.jpg": 13530
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 99332;